import React, { useState, useEffect, useContext, useRef } from "react";
import Header from "../../components/dashboard/header";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import SideMenu from "../student/SideMenu";
import Loader from "../../components/loader";
import SessionPopup from "../SessionPopup";
import SweetAlert from 'react-bootstrap-sweetalert';
import { ToastContainer, toast } from 'react-toastify';
import { contentContext } from "../../context/contentContext";
import tmdbApi from "../../api/tmdbApi";
import ShareDetailsContent from "./ShareDetailsContent";
import ExtendExpiryPanel from "./ExtendExpiryPanel";
import { useShareDetails } from "./useShareDetails";

const EditShareHistory = () => {
    const { shareid } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { isRestricted } = useContext(contentContext);
    const { shareData, isLoading, showSessionPopup } = useShareDetails(shareid, state?.shareData);
    const [isUpdating, setIsUpdating] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [now, setNow] = useState(Date.now()); // ticks every minute so time left stays current
    const extendPanelRef = useRef(null);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        const timer = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(timer);
    }, []);

    const handleBack = () => {
        navigate("/sharedlinks", { state: { restoreListPage: true } });
    };

    const handleExtendShare = async (hours) => {
        setIsUpdating(true);
        try {
            const response = await tmdbApi.updateShareHistory(shareData?.shareid || shareid, hours);
            if (response?.result === "Invalid token or Expired") {
                setSessionExpired(true);
                return;
            }
            setUpdateSuccess(true);
        } catch (err) {
            console.log('error', err);
            toast.error("Failed to update share link. Please try again.", { position: "bottom-center", autoClose: 2000, theme: "light" });
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <>
            {(showSessionPopup || sessionExpired) && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={!isLoading && !shareData && !showSessionPopup}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Shared link not found"}
                    onConfirm={handleBack}
                >
                </SweetAlert>
                <SweetAlert show={updateSuccess}
                    success
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Share link updated successfully"}
                    onConfirm={handleBack}
                >
                </SweetAlert>
                <div className="main-content user-management create-user" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">EDIT SHARED LINK</h4>
                                            <p className="menu-path" id="breadcrumb-path">
                                                <span>SHARED LINKS</span> / <b id="breadcrumb-action">EDIT SHARED LINK</b>
                                            </p>
                                        </div>
                                        <div>
                                            <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">BACK TO SHARED LINKS</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="create-user-block" id="create-user-block">
                                {!isLoading && shareData ? (
                                    <ShareDetailsContent
                                        shareData={shareData}
                                        shareid={shareid}
                                        now={now}
                                        hideCountdown
                                        canExtend={!isRestricted}
                                        onExtend={() => extendPanelRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })}
                                    >
                                        {!isRestricted && (
                                            <div ref={extendPanelRef}>
                                                <ExtendExpiryPanel
                                                    shareData={shareData}
                                                    now={now}
                                                    onSubmit={handleExtendShare}
                                                    isUpdating={isUpdating}
                                                />
                                            </div>
                                        )}
                                    </ShareDetailsContent>
                                ) : (
                                    <div className="form-block" id="loading-block">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="tab-pane active show" id="home1" role="tabpanel">
                                                <div className="row">
                                                    <Loader />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer position="bottom-center" autoClose={2000} newestOnTop closeOnClick pauseOnHover />
        </>
    );
};

export default EditShareHistory;
